import React from 'react'
import { Box, Flex, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useProductStore } from '../../../contexts/product'
import { IconSystemMinus, IconSystemPlus } from '@moonpig/launchpad-assets'
import { useLocaleText } from '../locale'

const MIN_QUANTITY = 1
const MAX_CARD_QUANTITY = 99

const StyledButton = styled(Flex)`
  background: transparent;
  border: none;
  ${s({
    typography: { xs: 'typeMobileDisplay02', md: 'typeDesktopDisplay04' },
    color: 'colorInteractionIcon',
  })}

  &:disabled {
    ${s({
      color: 'colorInteractionDeactivated',
    })}
  }
`

export const SimplifiedMultiBuyQuantityModule = () => {
  const localiseText = useLocaleText()
  const [{ quantity }, dispatcher] = useProductStore()

  const isDecreaseEnabled = quantity > MIN_QUANTITY
  const isIncreaseEnabled = quantity < MAX_CARD_QUANTITY

  const decrementQuantity = () => {
    dispatcher.selectQuantity(quantity - 1)
  }

  const incrementQuantity = () => {
    dispatcher.selectQuantity(quantity + 1)
  }

  return (
    <Box
      data-testid="module-simplified-multibuy-quantity"
      mb={{ xs: 6, md: '25px' }}
      width="100%"
    >
      <Box mb={2}>
        <Text
          color="colorTextLabel"
          typography={{
            xs: 'typeMobileBodyLabel',
            md: 'typeDesktopBodyLabel',
          }}
        >
          {localiseText('quantity_selector.quantity')}
        </Text>
      </Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        border="2px solid"
        borderColor="colorBlack40"
        borderRadius={2}
        px={5}
        height={48}
      >
        <StyledButton
          as="button"
          type="button"
          onClick={decrementQuantity}
          disabled={!isDecreaseEnabled}
          aria-disabled={!isDecreaseEnabled}
          aria-label={localiseText('quantity_selector.decrease_quantity')}
        >
          <IconSystemMinus height={'24px'} />
        </StyledButton>
        <Text
          color="colorTextBody"
          minHeight={'24px'}
          typography={{ xs: 'typeMobileBodyLabel', md: 'typeDesktopBodyLabel' }}
        >
          {quantity}
        </Text>
        <StyledButton
          as="button"
          type="button"
          onClick={incrementQuantity}
          disabled={!isIncreaseEnabled}
          aria-disabled={!isIncreaseEnabled}
          aria-label={localiseText('quantity_selector.increase_quantity')}
        >
          <IconSystemPlus height={'24px'} />
        </StyledButton>
      </Flex>
    </Box>
  )
}
